const Install = () => {
  return (
    <>Install</>
  )
}
export default Install
